import React from 'react';
import {useOfflineQueue} from '../hooks/useOfflineQueue';
import {useLanguage} from '../contexts/LanguageContext';
export default function SyncStatus() {
  const {isOnline, draftCount, isSyncing, error} = useOfflineQueue();
  const {t} = useLanguage();
  const attention = !isOnline || draftCount > 0 || error;
  return <span className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold ${attention ? 'bg-amber-50 text-amber-800' : 'bg-mint text-primary'}`} role="status">
    <span aria-hidden="true" className={`h-1.5 w-1.5 rounded-full ${attention ? 'bg-amber-500' : 'bg-primary'}`} />
    {error ? t('Check device records') : !isOnline ? t('Offline · saved on device') : isSyncing ? t('Syncing…') : draftCount ? t('{{count}} awaiting sync', {count: draftCount}) : t('No pending device records')}
  </span>;
}
